export interface StorageHealth { persistent: boolean; lowSpace: boolean }
let persistenceAttempted = false;
export async function storageHealth(requestPersistence = false): Promise<StorageHealth> {
  const storage = navigator.storage;
  if (!storage) return { persistent: false, lowSpace: false };
  let persistent = await storage.persisted?.().catch(() => false) ?? false;
  if (requestPersistence && !persistent && !persistenceAttempted && storage.persist) {
    persistenceAttempted = true;
    persistent = await storage.persist().catch(() => false);
  }
  const estimate = await storage.estimate?.().catch(() => ({} as StorageEstimate));
  const quota = estimate?.quota ?? 0;
  const usage = estimate?.usage ?? 0;
  return { persistent, lowSpace: quota > 0 && (usage / quota > .9 || quota - usage < 5 * 1024 * 1024) };
}
export function storageFailureMessage(error: unknown): string {
  const name = error && typeof error === 'object' && 'name' in error ? String(error.name) : '';
  return name === 'QuotaExceededError' ? 'This phone is out of storage. Your entry has not been saved. Free some device space, then try again.' : 'Could not save on this phone. Keep this entry open and try again.';
}
